import { useEffect, useState } from 'react';
import { useModifiedTranslation } from 'hooks/useModifiedTranslation';

export const useFeedI18nextWithLocale = (locale: string | undefined) => {
    const [isReady, setIsReady] = useState(false);
    const { i18n } = useModifiedTranslation();

    useEffect(() => {
        if (locale) {
            const normalizedLocale = locale.replace('_', '-');
            i18n.changeLanguage(normalizedLocale, () => {
                // WCAG 3.1.1 Language of Page - Update HTML lang attribute
                const langCode = normalizedLocale.split('-')[0];
                document.documentElement.lang = langCode;
                setIsReady(true);
            });
        }

        return () => {
            // Cancel any pending state updates
            setIsReady(false);
        };
    }, [locale, i18n]);

    return { isReady };
};
